import { Button } from "@mantine/core";

export function getUnknownErrorMessage(error: unknown): string {
	return error instanceof Error ? error.message : String(error);
}

export function getUnknownErrorStack(error: unknown): string {
	return error instanceof Error ? (error.stack ?? "") : "";
}

export function ErrorContent(props: {
	message?: string;
	errorMessage: string;
	errorStack: string;
	resetErrorBoundary?: () => void;
}) {
	const { message, errorMessage, errorStack, resetErrorBoundary } = props;

	return (
		<>
			{message && <p className="text-gray-600 mb-4">{message}</p>}
			<div className="w-full bg-gray-100 p-4 rounded-lg text-sm text-left overflow-auto">
				<p className="font-semibold mb-2">Message:</p>
				<p className="text-red-600 mb-2">{errorMessage}</p>
				<details className="text-gray-700">
					<summary className="cursor-pointer font-semibold mb-2">
						Stack trace:
					</summary>
					<pre className="whitespace-pre-wrap break-words text-sm mt-2">
						{errorStack}
					</pre>
				</details>
			</div>
			{resetErrorBoundary && (
				<div className="mt-6 flex gap-4">
					<Button variant="outline" onClick={resetErrorBoundary}>
						Try again
					</Button>
				</div>
			)}
		</>
	);
}
